
import React from "react"

import {  CARD } from "../modules/constants"
import { COLOR } from "../modules/colors_&_filters"
import { isSameDate } from "../modules/utilities"
import { formatDate_D_MM } from "../modules/dateFunctions"

import Card from '../components/ThemedCard'

import Tooltip from '@mui/material/Tooltip'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material/'

const OneCard = props => {
  const { id, cards, handleOnClick, portrait } = props
  const card = cards.find(obj => obj.id === id)
  // console.log('card:',card)

  return <Card variant="card" key={id} >
    <TableContainer sx={{ maxHeight: portrait ? null : 350, scrollbarWidth: "thin", scrollbarColor: `${COLOR.LIGHT_GREY} white` }}>
      <Table stickyHeader size="small">

        <TableHead>
          <TableRow>
            <TableCell colSpan={card.rows.length > 0 ? card.rows[0].length : 0}
              sx={{ fontSize: CARD.TITLE.FONT_SIZE, fontWeight: CARD.TITLE.FONT_WEIGHT, backgroundColor: CARD.TITLE.BACKGROUND_COLOR }}
            >
              {card.title}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {card.rows.map((row, index) => (
            <Tooltip key={index} title={getPropValueFromArray(row, "tooltip")} disableFocusListener>
              <TableRow hover={true} key={index} onClick={() => handleOnClick(getPropValueFromArray(row, "link"))} >
                {row.map((column, index) => {
                  if (column.link || column.tooltip) // Don't make a column for the link or tooltip
                    return null
                  else return (
                    <TableCell key={index} width={column.width} sx={establishRowStyle({ column, row })} >
                      {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                      {column.date && <span style={{ whiteSpace: 'nowrap' }}>{formatDate_D_MM(new Date(column.date))}</span>}
                      {column.logo && <img src={column.logo} alt="logo" style={{ maxHeight: 34, width: 40, marginTop: 3 }} />}
                      {column.value && <span style={column.style ?? {}}>{column.value}</span>}
                    </TableCell>
                  )
                }).filter(num => num !== null)}
              </TableRow>
            </Tooltip>
          ))}
        </TableBody>

      </Table>
    </TableContainer>
  </Card >
}

const establishRowStyle = ({ column, row }) => {
  const sx = {}
  // Add cursor = 'pointer' if the row has 'link' property
  if (getPropValueFromArray(row, "link"))
    sx.cursor = 'pointer'

  // Add fontWeight = 'bold' if the date is today
  if (isSameDate(new Date(getPropValueFromArray(row, "date")), new Date()))
    sx.fontWeight = 'bold'

  // Default spacing scale: 1 unit = 8px
  // So: p: 1 → 8px, p: 2 → 16px, p: 0.5 → 4px,
  // px: 1 py: 0.5 → 8px left/right, 4px top/bottom
  sx.padding = '6px 10px' // specifying vertical and horizontal padding.

  // horizontal alignment
  sx.textAlign = column.logo ? "center" : column.date ? "right" : column.align

  // vertical alignment
  sx.verticalAlign = 'top'

  return sx
}

// Finds an object with a specified property in an array and returns its value
function getPropValueFromArray(array, property) {
  const item = array.find(obj => property in obj)
  return item ? item[property] : ""
}


export default OneCard